import React from 'react';
import "./introduction.css";
import Graphic from "./Graphic/graphic";
import Highlights from "./Highlights/highlights";
import IdeaHighlights from "./IdeaHighlights/ideaHighlights";
import SkillsHighlights from "./SkillsHighlights/skillsHighlights";
import ExperienceHighlights from "./ExperienceHighlights/experienceHighlights";
import ProjectHighlights from "./ProjectsHighlights/projectHighlights";
import CredentialHighlights from "./CredentialHighlights/credentialHighlights";
import Contact from "./Contact/contact";
import Resume from "./Resume/resume";
import introduction from "./introduction.json";

const Introduction = () => {

    return (
        <div id='introduction'>
            <Graphic current={introduction.current} about_me={introduction.about_me}/>
            <Highlights data={introduction.current} about_me={introduction.about_me}/>
            <ExperienceHighlights data={introduction.experience_poster} />
            <ProjectHighlights data={introduction.current} />
            <SkillsHighlights data={introduction.current} />
            <CredentialHighlights data={introduction.current.credentials} />
            <Contact tabs={introduction.contact.tabs} />
            <Resume data={introduction.current} />
            <IdeaHighlights data={introduction.current} />
        </div>
    )
}

export default Introduction;